import React, { Component } from 'react';
import { connect } from 'react-redux';
import i18n from '../../../../i18next';

import MappingTypes from './MappingTypes';
import {
    loadOrderTypeMappings,
    updateOrderTypeMappings,
    loadPosOrderTypes,
    importPosOrderTypes
} from '../../../../actions/index';

class OrderTypeMappingScreen extends Component {
    constructor(props) {
        super(props);

        this.updateOrderTypeMappings = this.updateOrderTypeMappings.bind(this);
        this.importAllPosOrderTypes = this.importAllPosOrderTypes.bind(this);
    }

    componentDidMount() {
        const { id } = this.props.match.params;

        this.props.loadOrderTypeMappings(id);
        this.props.loadPosOrderTypes(id);
    }

    updateOrderTypeMappings(mappingTypes) {
        const { id } = this.props.match.params;
        this.props.updateOrderTypeMappings(this.transformMappingTypes(mappingTypes), id);
    }

    transformMappingTypes(mappingTypes) {
        const updatedMappings = [];

        mappingTypes.map(mapping => {
            const currentMapping = {
                id: mapping.id,
                orderType: {
                    id: mapping.mappingType.id,
                    value: mapping.mappingType.value
                },
                posOrderType: {
                    id: mapping.posType.id,
                    value: mapping.posType.value,
                    posId: mapping.posType.posId
                }
            }
            updatedMappings.push(currentMapping);
        });

        return updatedMappings;
    }

    importAllPosOrderTypes() {
        const { id } = this.props.match.params;
        this.props.importPosOrderTypes(id);
    }

    render() {
        const translationData = {
            heading: i18n.t('screens:restaurantsMainContainer.ordertype'),
            firstLabel: i18n.t('screens:orderTypeMappingScreen.orderType'),
            secondLabel: i18n.t('screens:orderTypeMappingScreen.posOrderType')
        };

        return (
            <MappingTypes
                params={this.props.match.params}
                mappingTypes={this.props.orderTypeMappings}
                update={this.updateOrderTypeMappings}
                posTypes={this.props.orderPosTypes}
                import={this.importAllPosOrderTypes}
                posSettings={this.props.posSettings}
                translations={translationData}
            />
        );
    }
}

const mapStateToProps = state => {
    return {
        orderTypeMappings: state.orderTypeMappings,
        orderPosTypes: state.orderPosTypes,
        posSettings: state.posSettings
    };
};

export default connect(
    mapStateToProps,
    {
        loadOrderTypeMappings,
        updateOrderTypeMappings,
        loadPosOrderTypes,
        importPosOrderTypes
    }
)(OrderTypeMappingScreen);


// WEBPACK FOOTER //
// ./src/components/restaurants/settings/pos/OrderTypeMappingScreen.js